import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { MUTATION_KEYS } from 'constants/common';
import { AppointmentService } from 'services/appointments';
import { type UploadDocumentPayload } from 'types/appointments';

export const useUploadDocument = (): UseMutationResult<void, Error, UploadDocumentPayload> => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  return useMutation<void, Error, UploadDocumentPayload>({
    mutationKey: [MUTATION_KEYS.UPLOAD_DOCUMENT],
    mutationFn: AppointmentService.uploadLocalDocument,
    retry: 1,
    onError: () => {
      toast.error(t('AppointmentsReserve.document.error'), { id: 'upload-document-error' });
    },
  });
};
